<template>
  <v-dialog v-model="isOpenDialog" width="36%" height="40%" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>TỔNG KẾT LẠI</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-col class="pt-6 px-6">
        <v-form ref="form">
          <v-radio-group v-model="reSummaryType">
            <v-radio value="default" label="Theo nhóm" />
            <v-radio value="specific" label="Theo đối tượng cụ thể" />
          </v-radio-group>
          <v-row v-if="reSummaryType === 'default'">
            <v-col cols="12" md="6" class="pb-10">
              <v-autocomplete
                v-model="typeGroup"
                clear-icon="mdi-close"
                :items="typeGroups"
                item-text="title"
                item-value="type"
                label="Phân loại nhóm"
                clearable
                outlined
                dense
                return-object
                :rules="[rule]"
                class="required style"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" class="pb-10">
              <v-autocomplete
                :disabled="isDisable"
                v-model="group"
                item-text="title"
                clear-icon="mdi-close"
                :items="groups"
                label="Nhóm đối tượng"
                clearable
                outlined
                dense
                return-object
                required
                :loading="loading"
                :rules="[rule]"
                class="required style"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <ReSummarySpecific @onSave="cancel" />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn width="97px" outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save">TỔNG KẾT LẠI</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { textHelpers } from '../../../helpers/TextHelper'
import ReSummarySpecific from './resummarySpecific/index.vue'

export default {
  components: { ReSummarySpecific },
  data() {
    return {
      rule: this.$rules.required,
      isOpenDialog: false,
      isDisable: true,
      group: {},
      typeGroup: null,
      groups: [],
      loading: false,
      typeGroups: [
        {
          title: 'Nhóm đối tượng chịu phí',
          type: 'normal'
        },
        {
          title: 'Nhóm đối tượng giảm trừ',
          type: 'priority'
        }
      ],
      reSummaryType: 'default'
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod'
    })
  },
  watch: {
    async typeGroup() {
      this.group = null
      this.groups = []
      if (this.typeGroup && this.typeGroup.type) {
        this.loading = true
        this.isDisable = false
        let list = await this.fetchAll({ type: this.typeGroup.type })
        this.groups = textHelpers.sortGroupFee(list)
        this.loading = false
      } else {
        this.$refs.form.reset()
        this.isDisable = true
        this.loading = false
      }
    },
    detailPeriod() {
      if (this.detailPeriod.status === 'running') {
        this.setLoadingFee(true)
      }
    }
  },
  methods: {
    ...mapActions('tuitionFeeReport', ['fetchAll']),
    ...mapActions('tuitonFeeHeadFee', ['fetchTuitionGroup', 'createGroupHeadFee', 'setRouter']),
    ...mapActions('tuitionFeeGroup', ['fetchGroups']),
    ...mapActions('tuitionFeePeriod', ['reSummary', 'setLoadingFee']),
    cancel() {
      this.isOpenDialog = false
      this.reset()
    },
    async save() {
      if (this.group && this.group.id) {
        this.$dialog.confirm({
          title: 'Xác nhận tổng kết lại?',
          text:
            'Thao tác này có thể mất một chút thời gian. Thông tin cũ có thể bị thay đổi và không thể hoàn tác. Bạn muốn tiếp tục tổng kết lại?',
          okText: 'Xác nhận',
          cancelText: 'Hủy',
          done: async () => {
            try {
              await this.reSummary({
                status: 'running',
                type: this.group.defaultType || 'custom',
                typeId: this.group.id,
                id: this.detailPeriod.id,
                generatedBy: this.user.id
              })
              this.isOpenDialog = false
              this.reset()
            } catch (e) {
              this.$alert.error(e)
            }
          }
        })
      } else {
        this.$refs.form.validate()
      }
    },
    openDialog() {
      this.isOpenDialog = true
    },
    reset() {
      this.loading = false
      this.group = {}
      this.typeGroup = null
      this.groups = []
      this.isDisable = true
      this.$refs.form.reset()
    }
  }
}
</script>
